import React, { Component, useState } from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import KSelect from './KSelect';

const pagesAndDefaultsTableDropdowns = {
  newProspectPage: {
    pageName: 'New Prospect Page',
    dropdowns: [
      {
        ddName: 'Communication Type',
        values: ['Phone Call', 'Email', 'Text', 'Web Form', 'Web Chat'],
      },
      {
        ddName: 'Referral Type',
        values: [
          'Company / Organization',
          'Word of Mouth',
          'Internet Search',
          'Social Media',
          'Media',
          'Marketing Event/Campaign',
          'Unknown',
        ],
      },
    ],
  },
};

const defaultsPanelStyle = (theme) => ({
  root: {
    margin: '12px',
    fontSize: '112%',
  },
});

const createPageHeaderStyles = makeStyles((theme) =>
  createStyles({
    panelTitle: {
      padding: '8px 0',
      borderBottom: '2px solid #4ec',
    },
  })
);

const PageHeader = () => {
  const classes = createPageHeaderStyles();
  return <div className={classes.panelTitle}>Set Default Values for Certain Dropdowns</div>;
};

const DefaultsTable = () => {
  const keys = Object.keys(pagesAndDefaultsTableDropdowns);
  return (
    <div>
      {keys.map((key) => (
        <DefaultsTableForPage key={key} pageCode={key} pageStruct={pagesAndDefaultsTableDropdowns[key]} />
      ))}
    </div>
  );
};

const createDefaultsTableStyles = makeStyles((theme) =>
  createStyles({
    defaultsSection: {
      marginTop: '12px',
      padding: '12px',
    },
    alertsTableQuasiHeader: {
      backgroundColor: '#ddd',
      height: '42px',
      paddingTop: '3px',
      paddingLeft: '12px',
    },
    defaultsTable: {
      margin: '4px 0 0 10px',
      borderCollapse: 'separate',
      borderSpacing: '10px 5px',
    },
  })
);

const DefaultsTableForPage = ({ pageCode, pageStruct }) => {
  const pageName = pageStruct.pageName;
  const ddStructs = pageStruct.dropdowns;

  const classes = createDefaultsTableStyles();

  return (
    <div className={classes.defaultsSection}>
      <div className={classes.alertsTableQuasiHeader}>{pageName}</div>
      <table className={classes.defaultsTable}>
        <tbody>
          {ddStructs.map((dds) => {
            const ddName = dds.ddName;
            const possibleValues = dds.values;
            return <DropDownDefaultRow key={ddName} pageCode={pageCode} name={ddName} values={possibleValues} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

const createDefaultsRowStyles = makeStyles((theme) =>
  createStyles({
    dropdownName: {
      fontWeight: 'bold',
    },
    defaultValueLabel: {
      paddingLeft: '12px',
    },
    valuesSelectorD: {
      paddingLeft: '6px',
    },
  })
);

const DropDownDefaultRow = ({ pageCode, name, values }) => {
  const settingName = 'dropdownSelectionDefaults';
  const prevDefaultsSettings = DA.getUserSetting(settingName); // an array of objects, one for each page with defaultable dropdowns
  const prevStructForThisPage = prevDefaultsSettings.find((s) => s.pageCode === pageCode); // an object {pageCode: 'newProspectPage', defaults: [...]}
  const prevStructsForThisPage = prevStructForThisPage ? prevStructForThisPage.defaults : []; // array of {ddName: 'Communication Type', defaultValue: 'Phone Call'}
  const prevStructForThisDropdown = prevStructsForThisPage
    ? prevStructsForThisPage.find((str) => str.ddName === name)
    : undefined;
  const prevDefaultForThisDropdown = prevStructForThisDropdown ? prevStructForThisDropdown.defaultValue : 'No Default';

  const [currentValue, setCurrentValue] = useState(prevDefaultForThisDropdown);

  const augmentedValues = ['No Default', ...values];

  const classes = createDefaultsRowStyles();

  const changeCurrentValue = (newValue) => {
    setCurrentValue(newValue);
    updateRedux(newValue);
  };

  const updateRedux = (newValue) => {
    const nameValuePairForThisDropdown = {
      ddName: name,
      defaultValue: newValue,
    };

    const allDdDefaultsSettings = DA.getUserSetting(settingName); // an array of objects, one for each page with defaultable dropdowns
    const structForThisPage = allDdDefaultsSettings.find((s) => s.pageCode === pageCode); // an object {pageCode: 'newProspectPage', defaults: [...]}
    const nameValuePairssForThisPage = structForThisPage ? structForThisPage.defaults : []; // array of {ddName: 'Communication Type', defaultValue: 'Phone Call'}
    const nameValuePairsForOtherRows = nameValuePairssForThisPage.filter((nvp) => nvp.ddName !== name); // array of {ddName: 'Communication Type', defaultValue: 'Phone Call'}
    const nameValuePairsForAllRowsForThisPage = [...nameValuePairsForOtherRows, nameValuePairForThisDropdown];

    const settingForThisPage = {
      pageCode: pageCode,
      defaults: nameValuePairsForAllRowsForThisPage,
    };

    const settingsForThisPageBesidesThisOne = allDdDefaultsSettings
      ? allDdDefaultsSettings.filter((setg) => setg.pageCode !== pageCode)
      : [];

    const settingsForAllPages = [...settingsForThisPageBesidesThisOne, settingForThisPage];

    ReduxLoader.setUserSetting(settingName, settingsForAllPages);
  };

  return (
    <tr key={name}>
      <td>Dropdown Name: </td>
      <td className={classes.dropdownName}>{name}</td>
      <td className={classes.defaultValueLabel}>Default to: </td>
      <td className={classes.valuesSelectorD}>
        <KSelect
          liveOptions={augmentedValues}
          value={currentValue}
          onChange={(event) => {
            changeCurrentValue(event.target.value);
          }}
        />
      </td>
    </tr>
  );
};

class DefaultDropdownValuesPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      redirect: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return (
        <div>
          <h1 style={{ color: 'red' }}>Error Encountered</h1>
          <h3>{this.state.errorMessage}</h3>
        </div>
      );
    }

    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <PageHeader />
        <DefaultsTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});
const actionProducers = {};
export default connect(mapStateToProps, actionProducers)(withStyles(defaultsPanelStyle)(DefaultDropdownValuesPanel));
